import React from 'react';

function Home() {
    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold">Welcome to the Home Page</h1>
            <p>This is the about page content.</p>
        </div>
    );
}

export default Home;